import { render, staticRenderFns } from "./MaterialCreationForm.vue?vue&type=template&id=e08edb62&scoped=true&"
import script from "./MaterialCreationForm.vue?vue&type=script&lang=js&"
export * from "./MaterialCreationForm.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCreationForm.vue?vue&type=style&index=0&id=e08edb62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08edb62",
  null
  
)

component.options.__file = "MaterialCreationForm.vue"
export default component.exports